<form class="cads-form" [formGroup]="_form()" (ngSubmit)="_onSubmit()" novalidate>
  <div class="cads-form__controls">
    @for (controlConfig of config().controls; track controlConfig.key) {
      @switch (controlConfig.kind) {
        @case ('input') {
          <cads-input
            [config]="_inputConfig(_asInput(controlConfig))"
            [formControlName]="controlConfig.key"
          />
        }
        @case ('textarea') {
          <cads-textarea
            [config]="_textareaConfig(_asTextarea(controlConfig))"
            [formControlName]="controlConfig.key"
          />
        }
        @case ('checkboxGroup') {
          <cads-checkbox-group
            [config]="_checkboxGroupConfig(_asCheckboxGroup(controlConfig))"
            [formControlName]="controlConfig.key"
          />
        }
        @case ('radioGroup') {
          <cads-radio-group
            [config]="_radioGroupConfig(_asRadioGroup(controlConfig))"
            [formControlName]="controlConfig.key"
          />
        }
        @case ('select') {
          <cads-select
            [config]="_selectConfig(_asSelect(controlConfig))"
            [formControlName]="controlConfig.key"
          />
        }
      }
    }
  </div>
  <div class="cads-form__actions">
    <cads-app-button [config]="_submitButtonConfig()" (tapped)="_onSubmit()" />
  </div>
</form>
